import { render, staticRenderFns } from "./asnUploadPhoto.vue?vue&type=template&id=039a76d4&"
import script from "./asnUploadPhoto.vue?vue&type=script&lang=js&"
export * from "./asnUploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./asnUploadPhoto.vue?vue&type=style&index=0&id=039a76d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports